// Queries and mutations for the Login module
import { gql } from 'apollo-boost';

export const LOGIN = gql`
mutation superadminLogIn($email: String!, $password: String!) {
    superadminLogIn(email: $email, password: $password) {
        user {
            id
            active
            isSuperadmin
            email
            firstName
            lastName
            countryAdmin
        }
        token
        errors
    }
}
`;


export const UPDATE_PASSWORD_MUTATION = gql`
mutation updatePassword($token: String!, $password: String!, $passwordConfirmation: String!) {
    updatePassword(token: $token, password: $password, passwordConfirmation: $passwordConfirmation) {
        user {
            id
            active
            isSuperadmin
            email
            firstName
            lastName
            countryAdmin
        }
        errors
        token
    }
}
`;

export const RESET_PASSWORD_MUTATION = gql`
mutation resetPassword($email: String!) {
    resetPassword(email: $email) {
        reset
        errors
    }
}
`;
export const FRANCHISE_LOGIN = gql`
mutation franchiseLogIn($email: String!, $password: String!) {
    franchiseLogIn(email: $email, password: $password) {
        user {
            id
            active
            isSuperadmin
            email
            firstName
            lastName
            countryAdmin
        }
        franchise {
            id
            name
        }
        token
        errors
    }
}
`;

export const FRANCHISE_INVITATION = gql`
query franchiseInvitation($franchiseId: ID!, $token: String!) {
    franchiseInvitation(franchiseId: $franchiseId, token: $token) {
        franchiseName
        email
        name
    }
}
`;

export const FRANCHISE_INVITE_ACCEPT = gql`
mutation franchiseInviteAccept($franchiseId: ID!, $token: String!, $name: String!, $password: String!, $passwordConfirmation: String!) {
    franchiseInviteAccept(franchiseId: $franchiseId, token: $token, name: $name, password: $password, passwordConfirmation: $passwordConfirmation) {
        user {
            id
            active
            isSuperadmin
            email
            firstName
            lastName
            countryAdmin
        }
        franchise { id }
        token
        errors
    }
}
`;
